import React from 'react'

const NotFoundView = () => <h1>Not found</h1>

export default NotFoundView
